import { jsx as i, jsxs as u } from "react/jsx-runtime";
import { u as s } from "./index-6a632112.mjs";
import { c as b, s as l, f as E, g as T, a as c } from "./themes-5f0b3c3d.mjs";
import { l as h } from "./lineHeights-72d3110c.mjs";
import * as t from "react";
import g, { useState as z, useEffect as A } from "react";
import { S as D } from "./caretLeft-980c1667.mjs";
import "./types-b577bf77.mjs";
const p = s.ul`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin: 0;
  align-items: center;
`, w = s.a`
  display: inline-block;
  color: ${(e) => e.theme.components.link.textColor};
  margin-right: 8px;
`, y = s.span`
  color: ${b.brandTwilight[600]};
  width: ${(e) => e.size === "medium" ? "6px" : e.size === "large" ? "7px" : "5px"};
  height: ${(e) => e.size === "medium" ? l["6x"] : e.size === "large" ? "26px" : l["5x"]};
  font-family: ${E.inter};
  font-style: normal;
  font-weight: ${T.primitive.fontWeights.inter.regular};
  font-size: ${(e) => e.size === "medium" ? c.small : e.size === "large" ? c.medium : c.xsmall};
  line-height: ${(e) => e.size === "medium" ? h.medium : e.size === "large" ? "26px" : h.small};
  margin-right: ${l["2x"]};
  margin-left: ${l["2x"]};
`, $ = "BREADCRUMBS_DATA_TEST_ID", U = ({
  children: e,
  size: a = "small",
  firstChildLink: o,
  dataTestId: n = $
}) => {
  const [m, x] = z(!1), d = t.Children.toArray(e), _ = d[0];
  return A(() => {
    const r = () => {
      x(window.innerWidth <= 600);
    };
    return r(), window.addEventListener("resize", r), () => window.removeEventListener("resize", r);
  }, []), /* @__PURE__ */ i("nav", { "aria-label": "breadcrumbs", children: m ? /* @__PURE__ */ i("div", { style: { display: "inline-block" }, children: /* @__PURE__ */ u(p, { "data-testid": n, children: [
    /* @__PURE__ */ i(w, { href: o, "aria-label": "mobile-chevron", children: /* @__PURE__ */ i(D, { size: "xs" }) }),
    t.cloneElement(_)
  ] }) }) : /* @__PURE__ */ i(p, { "data-testid": n, children: t.Children.map(d, (r, f) => t.isValidElement(r) ? /* @__PURE__ */ u(t.Fragment, { children: [
    r,
    f < d.length - 1 && /* @__PURE__ */ i(y, { size: a, children: "/" })
  ] }, f) : r) }) });
}, S = s.li`
  display: flex;
  list-style: none;
  padding: 0;
  align-items: center;
`, C = "BREADCRUMB__ITEM_DATA_TEST_ID", k = ({
  children: e,
  isCurrentPage: a,
  dataTestId: o = C
}) => {
  const n = g.Children.toArray(e);
  return /* @__PURE__ */ i(S, { "data-testid": o, children: n.map(
    (m) => g.cloneElement(m, {
      isCurrentPage: a
    })
  ) });
};
export {
  U as Breadcrumb,
  k as BreadcrumbItem
};
